"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpRadioButtonGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_bootstrap_1 = require("react-bootstrap");
var classnames_1 = __importDefault(require("classnames"));
var api_1 = require("../../../../api");
var react_i18next_1 = require("react-i18next");
var DpRadioButtonGroup = function (_a) {
    var buttons = _a.buttons, _b = _a.orientation, orientation = _b === void 0 ? 'vertical' : _b, _c = _a.selected, selected = _c === void 0 ? '' : _c, _d = _a.gutter, gutter = _d === void 0 ? 3 : _d, changeOptionHandler = _a.changeOptionHandler, _e = _a.name, name = _e === void 0 ? '' : _e;
    var wrapperStyles = (0, classnames_1.default)('radio-buttons d-flex ', {
        'justify-content-center': orientation === 'vertical',
        'flex-column': orientation === 'horizontal',
    });
    var ref = (0, react_1.useRef)(null);
    var focusIndex = (0, api_1.useRoveFocus)(buttons.length, ref)[0];
    var _f = (0, react_1.useState)(false), focused = _f[0], setFocused = _f[1];
    var t = (0, react_i18next_1.useTranslation)('common').t;
    (0, react_1.useEffect)(function () {
        if (focused) {
            var target = ref.current.querySelector("[data-index=\"".concat(focusIndex, "\"]"));
            target === null || target === void 0 ? void 0 : target.focus();
            target === null || target === void 0 ? void 0 : target.click();
        }
    }, [focusIndex, focused]);
    var radioGroupFocus = function () {
        setFocused(true);
    };
    return ((0, jsx_runtime_1.jsx)("div", { tabIndex: 0, className: wrapperStyles, ref: ref, onFocus: radioGroupFocus, children: buttons.map(function (_a, index) {
            var custom = _a.custom, label = _a.label, value = _a.value;
            return ((0, jsx_runtime_1.jsx)("div", { className: "pr-".concat(gutter), children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Form.Check, { type: "radio", id: value, label: label, name: name, value: value, checked: selected === value, onChange: changeOptionHandler, "aria-checked": selected === value, "data-index": index, tabIndex: -1, "aria-label": "".concat(label, " ").concat(index + 1, " ").concat(t('of'), " ").concat(buttons.length) }) }, value));
        }) }));
};
exports.DpRadioButtonGroup = DpRadioButtonGroup;
exports.default = exports.DpRadioButtonGroup;
